import { DashboardLayout } from "@/components";
import { stAdminMiddleware } from "@/middleware";
import { STAdminTickets } from "@/pages/st-admin";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const SearchSchema = z.object({
	status: z.enum(["OPEN", "CLOSED"]).optional(),
	page: z.coerce.number().int().min(1).optional(),
});

export const Route = createFileRoute("/st-admin/tickets/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => (
		<DashboardLayout>
			<STAdminTickets />
		</DashboardLayout>
	),
	loader: stAdminMiddleware,
});
